import { render } from "./ThreadMessage.vue?vue&type=template&id=7a241ad1&ts=true"
import script from "./ThreadMessage.vue?vue&type=script&lang=ts"
export * from "./ThreadMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__